import { Link } from "react-router-dom";
import getImageUrl from "../utils/getImageUrl";

export default function FeaturedArticleCard({ article, user, onDeleted }) {
  if (!article) return null;

  // Fallback to placeholder if no image exists
  const imageSrc = article.image
    ? getImageUrl(article.image)
    : getImageUrl("Placeholder.png"); // <-- filename you saved

  return (
    <Link to={`/articles/${article.id}`} className="featured-link">
      <div className="featured-article-card">
        {/* Image container */}
        <div className="featured-image-container">
          <img
            src={imageSrc}
            alt={article.title}
            className="featured-article-image"
          />
        </div>

        {/* Text content */}
        <div className="featured-article-content">
          <h2>{article.title}</h2>

          {article.category && (
            <p className="category-tag">{article.category}</p>
          )}

          <p className="byline">
            By {article.author} •{" "}
            {new Date(article.created_at).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </p>

          <p className="description">{article.description}</p>
          {user?.role === "admin" || user?.role === "superadmin" ? (
            <button
              className="admin-delete-btn"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                if (!window.confirm("Delete this article permanently?")) return;

                onDeleted(article.id);
              }}
              title="Delete article"
            >
              🗑
            </button>
          ) : null}
        </div>
      </div>
    </Link>
  );
}
